module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/money_200-9e7de4cb42860670fa1531b61bdc8bc1.png";